<div class="flex h-full cursor-pointer items-center" [class.expanded]="expanded()">
  <div class="flex h-full">
    @for (_ of [].constructor(nestingLevel()); track $index) {
      <span class="node-padding"></span>
    }
  </div>

  <mat-checkbox
    [checked]="selected()"
    [indeterminate]="indeterminate()"
    (change)="onCheckboxChangeHandler($event)"
    (click)="$event.stopPropagation()"
    color="primary"
  ></mat-checkbox>

  <span class="node-content ml-1 flex w-full items-center gap-2 overflow-hidden">
    <ng-content></ng-content>

    <span
      class="tree-cell-name text-primary truncate text-sm"
      [matTooltipPosition]="'right'"
      [matTooltip]="node().name"
    >
      {{ node().name }}
    </span>

    <ng-content select="[extra-content]"></ng-content>

    @if (isGroup()) {
      <dojo-icon
        [size]="12"
        class="node-content-icon chevron ml-auto"
        [icon]="expanded() ? 'chevron-down' : 'chevron-right'"
      />
    }
  </span>
</div>
